import React from "react";
import Modal from "../../commonComponents/util/Modal";
import NavigationComponent from "../../commonComponents/util/NavigationComponent";
import ValidatedInput from "../../commonComponents/util/ValidatedInput";
import RadioGroup from "../../commonComponents/util/RadioGroup";
import Toggle from "../../commonComponents/util/Toggle";
import Select from "../../commonComponents/util/Select";
import NumberFormat from "react-number-format";
import ValidatedPhoneInput from "../../commonComponents/util/ValidatedPhoneInput";
import AddressAutocomplete from "../../commonComponents/shared/AddressAutocomplete";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";
import {
  deepEquals,
  isValidEmail,
  toTitleCase,
  validateFieldLength
} from "../../../lib/utils";
import { RecipientTypes } from "../../../lib/systemVariables";
import { PhoneNumberTypes } from '../../../lib/constants';

export default class ReferenceModal extends NavigationComponent {
  initialState = {
    editReferenceId: null,
    preEditReference: null,
    referenceType: RecipientTypes.Individual,
    reference: {
      isIsraeli: false,
      institutionTitleId: null,
      personTitleId: null,
      firstName: "",
      lastName: "",
      orgName: "",
      position: "",
      address: {},
      phoneNumber: "",
      phoneType: PhoneNumberTypes.American,
      secondPhoneNumber: "",
      secondPhoneType: PhoneNumberTypes.American,
      email: "",
      isPayee: false,
      bankRoutingNumber: "",
      bankBranchNumber: "",
      bankAccountNumber: "",
      bankAccountHolder: ""
    },
    showSecondPhone: false,
    error: false,
    dataErrors: [],
    submitAttempted: false
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.show && nextProps.show && nextProps.reference) {
      const reference = {
        isIsraeli: nextProps.reference.isIsraeli,
        institutionTitleId: nextProps.reference.institutionTitleId,
        personTitleId: nextProps.reference.personTitleId,
        firstName: nextProps.reference.firstName || "",
        lastName: nextProps.reference.lastName || "",
        orgName: nextProps.reference.orgName || "",
        position: nextProps.reference.position || "",
        address: nextProps.reference.address || {},
        phoneNumber: nextProps.reference.phoneNumber || "",
        phoneType: nextProps.reference.phoneType || (nextProps.reference.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American),
        secondPhoneNumber: nextProps.reference.secondPhoneNumber || "",
        secondPhoneType: nextProps.reference.secondPhoneType || (nextProps.reference.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American),
        email: nextProps.reference.email || "",
        isPayee: false,
        bankRoutingNumber: nextProps.reference.bankRoutingNumber || "",
        bankBranchNumber: nextProps.reference.bankBranchNumber || "",
        bankAccountNumber: nextProps.reference.bankAccountNumber || "",
        bankAccountHolder: nextProps.reference.bankAccountHolder || ""
      };
      this.setState({
        editReferenceId: nextProps.reference.referenceId,
        preEditReference: reference,
        referenceType: reference.orgName
          ? RecipientTypes.Organization
          : RecipientTypes.Individual,
        reference,
        showSecondPhone: reference.secondPhoneNumber
      });
    }
  }

  onUpdateReferenceType = (name, value) => {
    const { reference, editReferenceId, preEditReference } = this.state;
    const initialReference = editReferenceId
      ? preEditReference
      : this.initialState.reference;

    if (value === RecipientTypes.Individual) {
      this.setState({
        [name]: value,
        reference: {
          ...reference,
          institutionTitleId: null,
          orgName: "",
          firstName: initialReference.firstName,
          lastName: initialReference.lastName
        }
      });
    } else if (value === RecipientTypes.Organization) {
      this.setState({
        [name]: value,
        reference: {
          ...reference,
          personTitleId: null,
          firstName: "",
          lastName: "",
          orgName: initialReference.orgName
        }
      });
    }
  };

  onUpdateReferenceIsIsraeli = (name, value) => {
    this.setState({
      reference: {
        ...this.state.reference,
        institutionTitleId: null,
        personTitleId: null,
        address: {},
        ...(!value
          ? {
            bankRoutingNumber: "",
            bankBranchNumber: "",
            bankAccountNumber: "",
            bankAccountHolder: ""
          }
          : {}),
          [name]: value,
      }
    });
  };

  onChange = (name, value) => {
    if (name === "firstName" || name === "lastName" || name === "orgName")
      value = toTitleCase(value);

    this.setState({ reference: { ...this.state.reference, [name]: value } });
  };

  onChangeEvt = event => {
    this.onChange(event.target.name, event.target.value);
  };

  onSubmit = async () => {
    this.setState({ error: false, submitAttempted: true });

    const reference = this.state.reference;
    if (
      this.state.dataErrors.length ||
      !(this.state.referenceType === RecipientTypes.Individual
        ? reference.lastName
        : reference.orgName) ||
      (reference.isPayee &&
        (reference.isIsraeli
          ? !reference.bankRoutingNumber
          || !reference.bankBranchNumber
          || !reference.bankAccountNumber
          : !reference.address))
    ) {
      return;
    }

    await this.props.submitReference(reference);

    if (this.props.success) {
      this.onClose();
    } else {
      this.setState({ error: true });
    }
  };

  onClose = () => {
    this.setState(this.initialState, this.props.close);
  };

  validateFieldLength = (name, length, value) => {
    const isValid = validateFieldLength(length, value);
    this.setDataError(name, !isValid);
    return isValid;
  };

  validateEmail = value => {
    const isValid = isValidEmail(value);
    this.setDataError("email", !isValid);
    return isValid;
  };

  setDataError = (errorName, error) => {
    let dataErrors = [...this.state.dataErrors];
    if (error) dataErrors.push(errorName);
    else dataErrors = dataErrors.filter(e => e !== errorName);
    this.setState({ dataErrors });
  };

  render() {
    const {
      reference,
      editReferenceId,
      preEditReference,
      referenceType,
      showSecondPhone,
      submitAttempted,
      dataErrors,
      error
    } = this.state;
    const { loading, usPersonTitles, israelPersonTitles, usInstitutionTitles, israelInstitutionTitles, recipientTypes } = this.props;
    const initialReference = editReferenceId
      ? preEditReference
      : this.initialState.reference;

    return (
      <Modal modalShowing={this.props.show}>
        <div className="modal-container">
          <div className="modal reference-modal large-modal">
            <div className="modal-header">
              <h4 className="page-header">
                {editReferenceId ? "Edit" : "New"} Reference
              </h4>
              <i
                className="icon ion-ios-close-empty"
                onClick={this.onClose.bind(this)}
              />
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <RadioGroup
                    options={recipientTypes}
                    title="Reference Type"
                    name="referenceType"
                    value={referenceType}
                    onChange={this.onUpdateReferenceType}
                  />
                </div>
                <div className="column-half">
                  <label className="input-label"></label>
                  <div className="flex-center">
                    <Toggle
                      id="isIsraeli"
                      name="isIsraeli"
                      value={reference.isIsraeli}
                      disabled={reference.isPayee}
                      onChange={this.onUpdateReferenceIsIsraeli}
                    />
                    <label className="small-text middle">Israeli</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-section">
              {referenceType === RecipientTypes.Individual ? (
                <div className="modal-row">
                  <div className="column-third">
                    <label className="input-label">Title</label>
                    <Select
                      clearable={true}
                      name="personTitleId"
                      value={reference.personTitleId}
                      options={reference.isIsraeli ? israelPersonTitles : usPersonTitles}
                      onChange={this.onChangeEvt}
                    />
                  </div>
                  <div className="column-third">
                    <ValidatedInput
                      input={<input type="text" />}
                      label="First Name"
                      name="firstName"
                      value={reference.firstName}
                      onChange={this.onChange}
                      required={reference.isPayee}
                      showRequiredError={submitAttempted}
                    />
                  </div>
                  <div className="column-third">
                    <ValidatedInput
                      input={<input type="text" />}
                      label="Last Name"
                      name="lastName"
                      value={reference.lastName}
                      onChange={this.onChange}
                      required={true}
                      showRequiredError={submitAttempted}
                    />
                  </div>
                </div>
              ) : (
                  <div className="modal-row">
                    <div className="column-half">
                      <label className="input-label">Institution Title</label>
                      <Select
                        clearable={true}
                        name="institutionTitleId"
                        value={reference.institutionTitleId}
                        options={reference.isIsraeli ? israelInstitutionTitles : usInstitutionTitles}
                        onChange={this.onChangeEvt}
                      />
                    </div>
                    <div className="column-half">
                      <ValidatedInput
                        input={<input type="text" />}
                        label="Name"
                        name="orgName"
                        value={reference.orgName}
                        onChange={this.onChange}
                        required={true}
                        showRequiredError={submitAttempted}
                      />
                    </div>
                  </div>
                )}
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <label className="input-label">Position</label>
                  <input
                    type="text"
                    name="position"
                    value={reference.position}
                    onChange={this.onChangeEvt}
                  />
                </div>
              </div>
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <AddressAutocomplete
                  title={
                    !reference.isIsraeli
                      ? "Address *Required if using the contact as payee"
                      : ""
                  }
                  isIsraeli={reference.isIsraeli}
                  required={!reference.isIsraeli && reference.isPayee}
                  showRequiredError={true}
                  address={reference.address}
                  updateAddress={this.onChange.bind(this, "address")}
                  updateError={() => this.setDataError("address")}
                />
              </div>
            </div>
            <div className="modal-section">
              <div className="modal-row">
                <div className="column-half">
                  <ValidatedPhoneInput
                    tabIndex={250}
                    span1={!showSecondPhone && <span
                      onClick={() =>
                        this.setState({ showSecondPhone: true })
                      }
                      className="link-text small-text"
                    >Add Phone </span>}
                    phoneNumber={reference.phoneNumber}
                    phoneType={reference.phoneType || (reference.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American)}
                    phoneNumberName="phoneNumber"
                    phoneTypeName="phoneType"
                    onChange={this.onChange}
                    error={dataErrors.indexOf("phoneNumber") >= 0}
                    updateError={this.setDataError}
                    errorName="phoneNumber"
                  />
                </div>

                <div className="column-half">
                  {showSecondPhone ?
                    <ValidatedPhoneInput
                      label="Second Phone"
                      phoneNumber={reference.secondPhoneNumber}
                      phoneType={reference.secondPhoneType || (reference.isIsraeli ? PhoneNumberTypes.Israeli : PhoneNumberTypes.American)}
                      phoneNumberName="secondPhoneNumber"
                      phoneTypeName="secondPhoneType"
                      onChange={this.onChange}
                      error={dataErrors.indexOf("secondPhoneNumber") >= 0}
                      updateError={this.setDataError}
                      errorName="secondPhoneNumber" />
                    : <ValidatedInput
                      input={<input type="text" />}
                      label="Email"
                      name="email"
                      value={reference.email}
                      onChange={this.onChange}
                      validated={true}
                      showValidationError={true}
                      validate={this.validateEmail}
                      errorMessage="Invalid Email Address"
                    />
                  }
                </div>
              </div>
            </div>

            {showSecondPhone && (
              <div className="modal-section">
                <div className="modal-row">
                  <div className="column-half">
                    <ValidatedInput
                      input={<input type="text" />}
                      label="Email"
                      name="email"
                      value={reference.email}
                      onChange={this.onChange}
                      validated={true}
                      showValidationError={true}
                      validate={this.validateEmail}
                      errorMessage="Invalid Email Address"
                    />
                  </div>
                </div>
              </div>
            )}

            {reference.isIsraeli && (
              <div>
                <div className="modal-row" style={{ paddingTop: "20px", marginBottom: "16px", borderTop: "2px solid #E0E5F2" }}>
                  <span className="small-text">If using the reference as payee:</span>
                </div>
                <div className="modal-row">
                  <div className="column-half">
                    <ValidatedInput
                      input={
                        <NumberFormat
                          placeholder="##"
                          format="##"
                          onValueChange={values =>
                            this.onChange("bankRoutingNumber", values.value)
                          }
                        />
                      }
                      label="Bank Number"
                      name="bankRoutingNumber"
                      value={reference.bankRoutingNumber}
                      required={reference.isPayee}
                      showRequiredError={submitAttempted}
                      errorMessage="Invalid Bank Number"
                      validated={true}
                      showValidationError={true}
                      validate={val =>
                        this.validateFieldLength("bankRoutingNumber", 2, val)
                      }
                    />
                  </div>
                  <div className="column-half">
                    <ValidatedInput
                      input={
                        <NumberFormat
                          placeholder="###"
                          format="###"
                          onValueChange={values =>
                            this.onChange("bankBranchNumber", values.value)
                          }
                        />
                      }
                      label="Branch Number"
                      name="bankBranchNumber"
                      value={reference.bankBranchNumber}
                      required={reference.isPayee}
                      showRequiredError={submitAttempted}
                      errorMessage="Invalid Branch Number"
                      validated={true}
                      showValidationError={true}
                      validate={val =>
                        this.validateFieldLength("bankBranchNumber", 2, val)
                      }
                    />
                  </div>
                </div>
                <div className="modal-row">
                  <div className="column-half">
                    <ValidatedInput
                      input={
                        <NumberFormat
                          placeholder="###############"
                          format="###############"
                          onValueChange={values =>
                            this.onChange("bankAccountNumber", values.value)
                          }
                        />
                      }
                      label="Account Number"
                      name="bankAccountNumber"
                      value={reference.bankAccountNumber}
                      required={reference.isPayee}
                      showRequiredError={submitAttempted}
                    />
                  </div>
                  <div className="column-half">
                    <label className="input-label">Account Holder</label>
                    <input type="text"
                      name="bankAccountHolder"
                      value={reference.bankAccountHolder}
                      onChange={e => this.onChange(e.target.name, e.target.value)} />
                  </div>
                </div>
              </div>
            )}

            {loading ? (
              <LoadingSpinner height="20" alignRight={true} />
            ) : (
                <div className="modal-btns text-right">
                  <button
                    className="btn btn-accent"
                    onClick={this.onClose.bind(this)}
                  >
                    Cancel
                </button>
                  <button
                    className="btn btn-primary"
                    disabled={
                      deepEquals(reference, initialReference) || dataErrors.length
                    }
                    onClick={this.onSubmit}
                  >
                    Submit
                </button>
                  <FadeOutErrorMessage show={error} />
                </div>
              )}
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/references/ReferenceModal.jsx